import React from 'react';
import { Link } from 'react-router-dom';
import styles from './FeatureTiles.module.scss';

interface Props {
  icon: string;
  heading: string;
  subheading: string;
  link: string;
  isNew?: boolean;
  handleOnClick: () => void;
}

const FeatureTile: React.FC<Props> = ({ icon, heading, subheading, link, isNew, handleOnClick }) => {
  return (
    <li className={styles.ListElement} key={heading}>
      <Link to={link} onClick={handleOnClick}>
        <div className={styles.TileContainer}>
          <i className={icon} />
          <div>
            <h4>{heading}</h4>
            <p>{subheading}</p>
          </div>
        </div>
        {isNew && <span className={styles.New}>New!</span>}
      </Link>
    </li>
  );
};

export default FeatureTile;
